import { TaskPriority } from "@fartherfinance/frontend/api/Tasks/Types";

import TaskPriorityIcon from "@src/multiCustodian/pages/Advisor/Tasks/TaskPriorityIcon/TaskPriorityIcon";

import { createStaticEnumEnhancer } from "./utils/createStaticEnumEnhancer";

export const TaskPriorityEnhancer = createStaticEnumEnhancer({
  enumKind: "TaskPriority",
  IconComponent: TaskPriorityIcon,
  createIconProps: (value: string) => ({ value: value as TaskPriority }),
});
